























import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import { deleteResource, DeleteResource } from '@/utils/delete-resource';

@Component({
  components: {
    Modal,
    BeatLoader,
  },
})
export default class ModalDelete extends Vue {
  @Prop()
  showModal!: boolean;

  @Prop({ default: 0 })
  resourceId: number | string;

  @Prop()
  resource: DeleteResource;

  @Prop()
  closeModal!: (isDeleted: boolean) => void;

  @Prop()
  title!: string;

  @Prop()
  description!: string;

  @Prop()
  buttonText!: string;

  width = '600px';

  isLoading = false;

  cancelClick() {
    this.closeModal(false);
  }

  async deleteClicked() {
    if (this.isLoading) return;

    this.isLoading = true;
    await deleteResource(this.resourceId, this.resource);

    this.closeModal(true);
    this.isLoading = false;
  }
}
